<template>
  <div class="iDalgo-Login-Main-Form-Container">
    <h1 class="iDalgo-Login-Main-Title" :style="loginMainTitle">
      <span class="iDalgo-Login-Main-Title-Icon" :style="loginMainTitleIcon">
        <i :class="`ida-icon-${product}`"></i>
      </span>
      {{ $t(`products.${product}.title`) }}
    </h1>

    <el-form class="iDalgo-Login-Main-Form" :model="credentials" :rules="rules" @keydown.enter.native="handleConnect">
      <el-form-item class="iDalgo-Login-Main-Form-ID" :label="$t('loginForm.ID.label')" prop="username">
        <el-input class="iDalgo-Login-Main-Form-ID-Input"
          v-model="credentials.username"
          :placeholder="$t('loginForm.ID.placeholder')" />
      </el-form-item>

      <el-form-item class="iDalgo-Login-Main-Form-Password" :label="$t('loginForm.password.label')" prop="password">
        <el-input
          :class="['iDalgo-Login-Main-Form-Password-Input', credentials.password ? 'filled' : '']"
          v-model="credentials.password"
          :placeholder="$t('loginForm.password.placeholder')"
          :type="this.passwordHidden ? 'password' : 'text'" />
        <svgicon
          class="iDalgo-Login-Main-Form-Password-Eye"
          name="eye"
          color="#545A67"
          width="18"
          @click="passwordHidden = !passwordHidden"></svgicon>
      </el-form-item>

      <el-form-item class="iDalgo-Login-Main-Form-Submit">
        <ida-button class="iDalgo-Login-Main-Form-Submit-Button" round color="#2E3545" height="50" :loading="loading" @click="handleConnect">
          {{ $t('loginForm.connect') }}
        </ida-button>

        <hr />

        <!-- Go to SSO login form -->
        <ida-button class="iDalgo-Login-Main-Form-Submit-Button" color="#9A4141" height="50" round @click="$router.push({ name: 'loginSSO', query: $route.query })">
          <span class="iDalgo-Login-Main-Redirect-Text">{{ $t('loginForm.connectSSO') }}</span>
          <svgicon name="key" color="#FFF" width="16" />
        </ida-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import '@/components/icons'
import { mapGetters } from 'vuex'
import styles from '@/assets/styles/styles.scss'

export default {
  name: 'iDalgo-Login-Form-Classical',
  data () {
    return {
      credentials: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: this.$t('loginForm.rules.username.empty'), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('loginForm.rules.password.empty'), trigger: 'blur' }
        ]
      },
      passwordHidden: true
    }
  },
  computed: {
    ...mapGetters({
      product: 'product/product',
      loading: 'auth/loading'
    }),
    loginMainTitle () {
      return {
        color: this.mainColor
      }
    },
    loginMainTitleIcon () {
      return {
        backgroundColor: this.mainColor
      }
    },
    mainColor () {
      return styles[`${this.product}Color`]
    }
  },
  methods: {
    handleConnect () {
      this.$store.dispatch('auth/login', this.credentials)
        .then(() => {
          window.location = this.$route.query.redirect
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/iDalgo-Login-Form-Classical.vue